// extracted by mini-css-extract-plugin
module.exports = {"status":"status__2x0q3","selected":"selected__3bYbi","warning":"warning__3UyrA","danger":"danger__3sPDv","success":"success__1Er0i","deny":"deny__1jXMQ"};